/**
 *
 * Asynchronously loads the component for Auth
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/components/Nav/Top/Loadable.js